import React from 'react';
import { Typography } from '../../common';
import { useCallTimer } from 'hooks/useCallTimer';

interface CallTimerProps {
  startTime?: string;
  variant?: 'small-heading-1' | 'h1' | 'h2' | 'h3' | 'h3-bold' | 'subText' | 'subText-2' | 'subHeading-1' | 'subHeading-2' | 'subHeading-3' | 'subHeading-4' | 'body-text-1' | 'body-text-2';
  className?: string;
}

const CallTimer: React.FC<CallTimerProps> = ({ 
  startTime, 
  variant = 'small-heading-1', 
  className 
}) => {
  const timer = useCallTimer(startTime);

  return (
    <Typography variant={variant} className={className}>
      {startTime ? timer : '00:00'}
    </Typography>
  );
};

export default React.memo(CallTimer, (prevProps, nextProps) => {
  return prevProps.startTime === nextProps.startTime;
});
